import { NgModule } from '@angular/core';
import { AISSTREAM_TOOLBAR_CONFIG_PROVIDERS } from './aisstream-toolbar.config';

/**
 * AISSTREAM — everything this provider contributes to the map (D16).
 *
 * Which is: its bar composition, and nothing else.
 *
 * NO DECLARATIONS, and that emptiness is the architecture reporting rather than
 * an oversight. Every control on this sensor's two bars is one of the sixteen
 * provider-neutral ones in `AisSharedModule` — a control is shared when its
 * state and its action both live on `PlaybackController` (D9), and everything
 * AISstream mounts does. Its rendering is a `@Injectable` controller that owns
 * a bare Leaflet map, so it has no components of its own to declare.
 *
 * The day it wants a search drawer or a paid action, that changes: it gains a
 * controls file, a descriptors file whose entries carry `operatorKey`, and a
 * `declarations` array here. Nothing shared changes on that day either.
 *
 * `AisSharedModule` is NOT imported. Nothing here has a template, so there is
 * nothing to resolve; importing it would only assert a dependency that does not
 * exist. The map component imports it directly for the toolbar host.
 */
@NgModule({
  providers: [...AISSTREAM_TOOLBAR_CONFIG_PROVIDERS],
})
export class AisstreamModule {}
